import { Dispatch, SetStateAction } from 'react';
import S from './ResetFilterStyles';
import Icon from '../Icon/Icon';
import { IconKeys } from '../Icon/IconKeys';

type Props = {
  filters?: Record<string, string[]>;
  defaultFilters?: Record<string, string[]>;
  setFilters: Dispatch<SetStateAction<Record<string, string[]>>>;
};

const areStringArraysEqual = (a: string[] = [], b: string[] = []): boolean => {
  if (a.length !== b.length) {
    return false;
  }

  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((value, index) => value === sortedB[index]);
};

const areFiltersEqual = (
  left: Record<string, string[]> = {},
  right: Record<string, string[]> = {},
): boolean => Object.keys(left)
  .every((key) => areStringArraysEqual(left[key] || [], right[key] || []));

function ResetFilter({
  filters = {}, defaultFilters = {}, setFilters,
}: Props): JSX.Element | null {
  const isActive = !areFiltersEqual(filters, defaultFilters);

  return (
    <S.Wrapper title="Reset filters" $isActive={isActive}>
      <button
        type="button"
        onClick={() => {
          setFilters(
            Object.fromEntries(
              Object.entries(defaultFilters).map(([k, v]) => [k, [...v]]),
            ) as Record<string, string[]>,
          );
        }}
      >
        <Icon iconKey={IconKeys.CLOSE} />
      </button>
    </S.Wrapper>
  );
}

export default ResetFilter;
